<!--  -->
<template>
  <div class="main_w">
    <div class="v2" v-if="qaDetail.id === '0'">
      <p class="artical_c">
        <span class="artical_title">1.工程师报名</span>
      </p>
      <p class="artical_c">
        客户需求经平台审核成功并发布后，会以订单形式展示在APP“市场”页面，工程师可通过“城市”、“技术方向”等条件筛选与自身匹配的订单进行报名，报名完成后可在APP“服务工作台”中查询相关订单。
      </p>
      <p class="artical_c">
        <span class="artical_title">2.客户选择工程师</span>
      </p>
      <p class="artical_c">
        完成报名后，可等待与客户就订单需求进行沟通确认，客户会选择合适的工程师中标。
      </p>
      <p class="artical_c">
        <span class="artical_title">3.生成服务协议</span>
      </p>
      <p class="artical_c">
        客户选定工程师后，双方可在线发起协议并完成签约，协议内容需双方按照沟通约定内容通过线上模版协议进行填写确认，确认🥹无误后方可签订协议。
      </p>
      <p class="artical_c">
        <span class="artical_title">4.托管服务费</span>
      </p>
      <p class="artical_c">
        双方在线签订协议后，需由客户根据协议约定价格在线托管服务费用，完成服务费托管后方可等待服务实施。
      </p>
      <p class="artical_c"><span class="artical_title">5.服务实施</span></p>
      <p class="artical_c">
        工程师按照与客户约定的时间上门或远程提供服务，实施过程需完全按照协议约定要求进行。
      </p>
      <p class="artical_c">
        工程师到场后，需在线完成“签到打卡”和“提交验收”动作，按照APP提示要求完成相关的照片上传和交付动作，提交验收后选择验收方式等待客户验收。
      </p>
      <p class="artical_c">
        <span class="artical_title">6.验收及付款</span>
      </p>
      <p class="artical_c">
        客户“确认验收”后，系统将扣除个税后的订单酬劳转入工程师账户中，工程师可在“我的银行卡”中完成本人银行卡绑定，之后可在“服务工作台”——“订单提现”中进行相关完成订单的提现申请。
      </p>
      <p class="artical_c"><span class="artical_title">服务结束</span></p>
    </div>
    <div class="v1" v-else>
      <Row type="flex" style="margin-bottom: 0.2rem">
        <div class="tag">Q</div>
        <div style="flex: 1" class="t">{{ qaDetail.q }}</div>
      </Row>
      <div style="padding-left: 0.6rem">
        <Divider />
      </div>
      <Row type="flex">
        <div class="tag tag_a">A</div>
        <div style="flex: 1" class="t">{{ qaDetail.a }}</div>
      </Row>
    </div>
  </div>
</template>

<script>
import { Col, Row, Divider } from "vant";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Col,
    Row,
    Divider,
  },
  data() {
    //这里存放数据
    return {
      qaMap: [
        {
          id: "0",
          q: "服务流程",
        },
        {
          id: "1",
          q: "提现几天可以到账？",
          a: "一般是客户确认验收，您申请提现且平台审核通过后可执行付款流程，到账周期为申请提现的30天后。若出现不可抗力原因，到账可能延迟。",
        },
        {
          id: "2",
          q: "怎么样才能提高自己的中标率？",
          a: "客户挑选工程师合作，主要考量工程师技术能力、资质证书、星级评分、历史交付评价几个方面，您在报名接单前，应准确全面的完善您的账号信息，详细填写“我的技能”、“接单偏好”，并提交相关资质、能力证书完成认证，良好的服务态度和服务意识将有助于提升中标概率。",
        },
        {
          id: "3",
          q: "邦邦平台收取平台管理费吗？",
          a: "平台以每笔订单金额按10%的比例向工程师收取平台服务费，作为平台日常运营和为工程师代缴相关税费的成本补充，但平台为维护工程师权益，会对服务费进行补贴，工程师可以通过缴纳保证金享受3%、5%、7%三个档位的补贴权益，具体请参见保证金管理制度。\r\n如接单主体为公司等法人体，平台将扣除开票相关税费。接单主体进行提现时，需预先提供相关订单对应金额的发票，方可正常提现到账。",
        },
        {
          id: "4",
          q: "为什么没有通过认证就不能报名订单？",
          a: "根据国家相关法规，未经过身份认证的电子协议不受法律保护。为保护您的合法权益，平台规定，没有进行身份认证，不能够进行报名订单。为便于您在平台上承接业务，请尽快完成身份认证。\r\n身份认证方法：您通过平台上传身份证照片后，平台工作人员将尽快为您进行认证。",
        },
        {
          id: "5",
          q: "为什么在个人信息中必须设置昵称和头像？",
          a: "为保护工程师个人隐私，系统在显示工程师信息时只显示工程师的姓氏，比如李工程师，王工程师。\r\n但由于同姓的工程师太多，当同一订单报名人数较多的时候，客户容易认错或者混淆，为便于客户识别工程师或者收藏工程师，系统要求必须设置呢称和个性头像。\r\n同时工程师在邦邦社区进行互动时，显示昵称和头像，将在更方便用户交流的同时，保护用户隐私",
        },
        {
          id: "6",
          q: "我被选中了，可以主动取消报名吗？",
          a: "可以。\r\n在工程师生成协议发送给客户前，或客户生成协议但工程师尚未确认前，可以取消报名。不过最好及时通知客户，让客户有时间去选择新的工程师合作。\r\n如果工程师生成协议发送给客户，或客户生成协议工程师已确认，则不能取消报名。如果坚持要求取消，工程师可通知客户，请客户在他的APP上取消对工程师的选择。",
        },
        {
          id: "7",
          q: "在托管服务费之前，客户可以取消订单吗？",
          a: "可以。\r\n客户在没有签订协议并托管服务费前是可以取消订单的。",
        },
        {
          id: "8",
          q: "客户托管服务费之后。可以取消订单吗？",
          a: "不能。\r\n此时客户和您的电子协议在法律上已经生效。如此时您因为各种原因无法继续履行订单，请务必和我们的客服联系。\r\n取消订单请务必在订单约定的开始实施时间前提前进行（上午实施应在前一天进行通知，当日实施请提前6小时进行通知），以避免影响客户的安排和实施。如您未在上述时间范围内反馈取消，给客户带来确定的直接损失的，您需要承担相应的责任。",
        },
        {
          id: "9",
          q: "客户的预算价格就是最终价格吗？",
          a: "预算价格是客户预估的服务费用，不一定等于最终服务价格。\r\n由于服务方案不一样，工程师水平不一样，服务价格会有所不同。如果您不同意对方的预算价格，请在双方沟通时提出并协商。您可以与客户进行充分的沟通，让客户了解服务细节和您的报价，你们沟通的越详细清晰，客户选择您的可能性就越大。\r\n当客户选择您，你们双方沟通好交付内容和价格并写入协议中，此时价格为最终服务价格。",
        },
        {
          id: "10",
          q: "客户的预算价格可以修改吗？",
          a: "工程师报名时不能修改对方预算。但双方可在充分沟通并达成一致的前提下，在签订服务协议时将协议金额填写为双方最终确认的服务费金额。",
        },
        {
          id: "11",
          q: "星级的评分标准是什么？",
          a: "评分标准为：\r\n1.好评为2分，中评为1分，差评为-6分；\r\n2.40分为一星，以此类推；\r\n3.200分为一钻，以此类推；\r\n4.1000分为一皇冠，以此类推。\r\n工程师获得的评价以及星级将会是客户挑选工程师的重要的依据。好评越多，星级越高，中标的概率就越大。",
        },
        {
          id: "12",
          q: "关于对工程师爽约的处罚",
          a: "爽约是指工程师签订了电子协议但由于自身的原因，没有按双方约定或者协议规定的时间实施服务，引发客户在平台投诉，甚至使用法律途径维权的行为。\r\nIT服务作为服务业的一种，恪守契约是基本的职业道德，无故爽单是非常恶劣的行为。神州邦邦平台对此类事件零容忍：爽单且没有合理解释（需提供相应证据）的工程师将记入黑名单，平台不再与之发生任何合作。\r\n如因有意外原因推迟交付或不能实施交付，请及时与客户沟通，取得客户的理解，并积极配合商讨解决方案。\r\n取消订单请务必在订单约定的开始实施时间前提前进行（上午实施应在前一天进行通知，当日实施请提前6小时进行通知），以避免影响客户的安排和实施。如您未在上述时间范围内反馈取消，给客户带来确定的直接损失的，您需要承担相应的责任。",
        },
        {
          id: "13",
          q: "纠纷处理",
          a: "如果客户认为工程师违反双方的协议，可以拒绝“验收”，这样将进入“维权”阶段。神州邦邦平台的工作人员会介入，调解双方矛盾。如果双方矛盾无法调和，可通过法律途径维护自身合法权益。",
        },
        {
          id: "14",
          q: "怎样方便的找到客服或者提出意见建议?",
          a: "1.在APP里任何界面，把手机摇一摇，即可马上呼出客服和投诉建议界面。\r\n2.进入“个人中心”，即可找到“联系客服”和“意见建议”。\r\n3.部分涉及到沟通交流的页面右上角，有联系客服的图标，点击即可发起与平台客服的在线交流。",
        },
      ],
      qaDetail: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.$route.query.id === "0") {
      document.title = "服务流程";
    }
    this.qaDetail = this.qaMap.find((item) => item.id === this.$route.query.id);
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.main_w {
  min-height: 100vh;
  background-color: #f5f7fa;
  width: 100%;
}
.v1 {
  background: #fff;
  padding: 0.24rem 0.32rem;
  .tag {
    line-height: 0.5rem;
    height: 0.5rem;
    width: 0.5rem;
    text-align: center;
    font-size: 0.28rem;
    border-radius: 0.08rem;
    color: #fff;
    background: #3f81c1;
    margin-right: 0.2rem;
  }
  .tag_a {
    background: #e98f36;
  }
  .t {
    color: #323233;
    font-size: 0.28rem;
    line-height: 0.4rem;
    white-space: pre-line;
  }
}
.v2 {
  background: #fff;
  padding: 0 0.32rem 0.24rem;
  .artical_c {
    font-size: 0.24rem;
    line-height: 0.3rem;
  }
  .artical_title {
    font-weight: bold;
    font-size: 0.26rem;
    color: #353535;
    line-height: 0.5rem;
    display: block;
    margin-top: 0.2rem;
  }
}
</style>